var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "helysz\\xEDn_ikon",
    transform: "translate(-1812.287 -601.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10866",
    d: "M1838.787,632.2h-22a4.506,4.506,0,0,1-4.5-4.5v-22a4.5,4.5,0,0,1,4.5-4.5h22a4.5,4.5,0,0,1,4.5,4.5v22A4.5,4.5,0,0,1,1838.787,632.2Zm-22-30a3.5,3.5,0,0,0-3.5,3.5v22a3.505,3.505,0,0,0,3.5,3.5h22a3.5,3.5,0,0,0,3.5-3.5v-22a3.5,3.5,0,0,0-3.5-3.5Z",
    fill: "#929ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10867",
    d: "M1827.2,605.739a8.8,8.8,0,0,0-8.806,8.807c0,4.859,8.806,13.106,8.806,13.106s8.8-8.118,8.8-13.106A8.8,8.8,0,0,0,1827.2,605.739Zm-.283,11.481a3.59,3.59,0,1,1,3.586-3.595A3.592,3.592,0,0,1,1826.915,617.22Z",
    fill: "#929ea7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.3339e0b3272ed5db21a1349ccebece78.svg";
export { ForwardRef as ReactComponent };